import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';
import { cn } from '@/lib/utils';

interface AppShellProps {
  children: ReactNode;
  /** Hide the tab bar on flows that own the whole screen (a live call). */
  showNav?: boolean;
  className?: string;
}

/**
 * The phone-width column every page renders in.
 *
 * Mobile-first: at phone width it is the viewport; on a tablet or desktop it
 * is a centred column with the page background either side, so the layout
 * never stretches a three-column tile grid across a 27-inch monitor. Bottom
 * padding leaves room for the tab bar and the home-indicator inset.
 */
export function AppShell({ children, showNav = true, className }: AppShellProps) {
  return (
    <div className="bg-background min-h-dvh">
      <div
        className={cn(
          'bg-background relative mx-auto flex min-h-dvh w-full max-w-md flex-col',
          showNav && 'pb-[calc(4.25rem+env(safe-area-inset-bottom))]',
          className,
        )}
      >
        {children}
      </div>
      {showNav && <BottomNav />}
    </div>
  );
}
